// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__lNYZW","text":"SectionHeader_text__XVsqD","title":"SectionHeader_title__uqxjo","description":"SectionHeader_description__dHYZb"};